import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const handPaintingsData = [
  {
    id: 1,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/Components/HandpaintingFifthSlide/1.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 2,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/Components/HandpaintingFifthSlide/2.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 3,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/Components/HandpaintingFifthSlide/3.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 4,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/Components/HandpaintingFifthSlide/4.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 5,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/Components/HandpaintingFifthSlide/5.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 6,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/banners/1.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 7,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/banners/2.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 8,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/banners/3.jpg",
    link: "/exclusivehandpaintings",
  },
  {
    id: 9,
    img: "https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/banners/4.jpg",
    link: "/exclusivehandpaintings",
  },
];

const HandPaintings = () => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);

  // Scroll 3 cards to the left
  const scrollLeft = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const firstCard = container.querySelector('.hand-painting-card');
      if (firstCard) {
        const cardWidth = firstCard.getBoundingClientRect().width;
        const gap = 16; // gap between cards
        const scrollAmount = (cardWidth + gap) * 3;
        container.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  };

  // Scroll 3 cards to the right
  const scrollRight = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const firstCard = container.querySelector('.hand-painting-card');
      if (firstCard) {
        const cardWidth = firstCard.getBoundingClientRect().width;
        const gap = 16;
        const scrollAmount = (cardWidth + gap) * 3;

        // If at or near end, loop back to start
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 15) {
          container.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          container.scrollBy({
            left: scrollAmount,
            behavior: 'smooth',
          });
        }
      }
    }
  };

  return (
    <section className="relative w-full bg-white py-12 sm:py-16 font-serif overflow-hidden">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        
        {/* Header Section with Decorative Line */}
        <header className="text-center mb-8 sm:mb-10 group" data-aos="fade-up">
          <h2 className="relative inline-block text-3xl sm:text-4xl md:text-5xl font-serif text-gray-800 tracking-tight pb-3">
            Explore Hand Paintings
            {/* Elegant underline */}
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-28 h-1 bg-yellow-600 rounded-full transition-all duration-300 group-hover:w-36" />
          </h2>

          <p className="mt-4 text-sm sm:text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4 font-sans font-light">
            Hand-painted originals where every stroke tells a story. Crafted with soul to bring depth, charm, and authenticity to your space.
          </p>
        </header>

        {/* 3 Images Per Lane Row Slider Container */}
        <div className="relative max-w-7xl mx-auto" data-aos="fade-up" data-aos-delay="150">
          
          {/* Scrollable Container with 3 items per view on all screens */}
          <div
            ref={scrollContainerRef}
            className="flex overflow-x-auto gap-3 sm:gap-4 md:gap-6 px-1 py-3 no-scrollbar scroll-smooth snap-x snap-mandatory"
          >
            {handPaintingsData.map((item) => (
              <div
                key={item.id}
                className="hand-painting-card w-[calc((100%-16px)/3)] sm:w-[calc((100%-24px)/3)] md:w-[calc((100%-48px)/3)] flex-shrink-0 snap-start group select-none"
              >
                <Link to={item.link} className="block w-full h-full">
                  <div className="relative w-full aspect-[3/4] sm:aspect-square overflow-hidden rounded-2xl bg-gray-100 shadow-md hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-1">
                    <img
                      src={item.img}
                      alt="Hand Painting"
                      className="w-full h-full object-cover rounded-2xl transition-transform duration-700 ease-out group-hover:scale-110"
                      loading="lazy"
                    />

                    {/* Luxury Hover Overlay with Animated Explore Collection Button */}
                    <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center p-2 sm:p-4 pointer-events-none">
                      <span className="transform translate-y-3 group-hover:translate-y-0 transition-all duration-300 ease-out px-3 sm:px-5 py-1.5 sm:py-2.5 bg-white/95 text-gray-900 font-serif text-[11px] sm:text-xs md:text-sm font-medium tracking-wider uppercase rounded-full shadow-2xl border border-white/50 group-hover:scale-105">
                        Explore Collection
                      </span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {/* Desktop / Tablet Scroll Left Button */}
          <button
            onClick={scrollLeft}
            className="absolute -left-12 lg:-left-16 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 z-10 hidden md:block opacity-75 hover:opacity-100 transition-opacity duration-300"
            aria-label="Scroll left"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Desktop / Tablet Scroll Right Button */}
          <button
            onClick={scrollRight}
            className="absolute -right-12 lg:-right-16 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 z-10 hidden md:block opacity-75 hover:opacity-100 transition-opacity duration-300"
            aria-label="Scroll right"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Mobile Scroll Left Button */}
          <button
            onClick={scrollLeft}
            className="absolute -left-1 top-1/2 -translate-y-1/2 bg-gray-900/80 text-white p-2 rounded-full shadow-lg hover:bg-gray-800 focus:outline-none z-10 md:hidden opacity-80"
            aria-label="Scroll left"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Mobile Scroll Right Button */}
          <button
            onClick={scrollRight}
            className="absolute -right-1 top-1/2 -translate-y-1/2 bg-gray-900/80 text-white p-2 rounded-full shadow-lg hover:bg-gray-800 focus:outline-none z-10 md:hidden opacity-80"
            aria-label="Scroll right"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Explore Collection Action Button */}
        <div className="text-center mt-8 sm:mt-10" data-aos="fade-up" data-aos-delay="200">
          <Link
            to="/exclusivehandpaintings"
            className="inline-block bg-gray-900 hover:bg-gray-800 text-white font-serif font-medium py-3 px-8 rounded-full transition-all duration-300 shadow-md hover:shadow-xl hover:scale-105"
          >
            Explore Full Collection
          </Link>
        </div>

      </div>
    </section>
  );
};

export default HandPaintings;